//@flow
export default class Event {
  /**
   * The client version
   */
  clientVer: string;
  /**
   * The event type
   */
  eventType: number;
  /**
   * The client's timestamp of this event
   */
  eventTimestamp: number;
  /**
   * The session id. A unique string generated by the client that will represent the client-side session
   * */
  sessionId: string;
  /**
   * The partner id
   */
  partnerId: number;
  /**
   * The entry id
   */
  entryId: string;
  /**
   * The playlist id
   */
  playlistId: ?string;
  /**
   * The widget id
   */
  widgetId: string;
  /**
   * The uiconf id
   */
  uiconfId: number;
  /**
   * The partner's user id
   */
  userId: number;
  /**
   * The timestamp along the video when the event happened
   */
  currentPoint: number;
  /**
   * The duration of the video in milliseconds
   */
  duration: number;
  /**
   * Whether the user ever used seek in this session
   */
  seek: boolean;
  /**
   * The referrer of the client
   */
  referrer: string;
  /**
   * Whether the event is thrown for the first video in the session
   */
  isFirstInSession: boolean;
  /**
   * The vidiun application name
   */
  applicationId: string;
  /**
   * The context id
   */
  contextId: number;
  /**
   * The feature type
   */
  featureType: number;
  /**
   * Whether kanalony plugin is enabled
   */
  hasKanalony: boolean;

  /**
   * @constructor
   * @param {number} eventType - The event type
   */
  constructor(eventType: number) {
    this.eventType = eventType;
    this.isFirstInSession = false;
    this.eventTimestamp = new Date().getTime();
  }
}



// WEBPACK FOOTER //
// ./event.js


// WEBPACK FOOTER //
// vanalytics/event.js